import {MessageCodes} from "../MessageCodes";
import ResultTable from "../../Table/ResultTable";
import ResultText from "../ResultText";
import {useUser} from "../../../Context/UserContext";
import EmptyLine from "../../EmptyLine";
import ResultHeader from "../../Table/ResultHeader";
import ResultRow from "../../Table/ResultRow";
import ResultHeaderCell from "../../Table/ResultHeaderCell";
import HecRasHelper from "../../../Helpers/HecRasHelper";
import ResultBody from "../../Table/ResultBody";
import ResultBodyCell from "../../Table/ResultBodyCell";
import StationElevationPlot from "../UI/StationElevationPlot";
import ResultView from "../../V2/ResultView";

export function XS4({data, message_key}) {
    const {settings} = useUser()

    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} settings={settings} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const StaElevPlot = ({riverStation, globalVariables, layers}) => {
    return (
        <>
            <StationElevationPlot
                crossSection={riverStation?.cross_section}
                plotData={{
                    base: riverStation?.plot_base,
                }}
                globalVariables={globalVariables}
                layers={layers}
            />
        </>
    )
}

const Description = ({text, row, settings, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Internal.XS4_XS06.error_id: {
            return (
                <>
                    <ResultText>
                        The left and right bank station elevations are not consistent for the following {row?.data?.length} cross sections. The slope of the line connecting the L and R bank stations of the cross section are listed. The cross sections with a bank station slope higher than or equal to {settings?.thresholds?.bs_slope} are listed in the table. The average and sample standard deviation of slopes within the reach is calculated as average = {row?.average}, standard deviation = {row?.std}.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable  data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}></ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{textAlign: 'center', width: HecRasHelper.getWidth(16)}}>Station (ft)</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{textAlign: 'center', width: HecRasHelper.getWidth(16)}}>Elevation (ft)</ResultHeaderCell>
                                <ResultHeaderCell colSpan={3} style={{textAlign: 'center', width: HecRasHelper.getWidth(26)}}>Variables</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>L. Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>R. Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>L. Elev</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>R. Elev</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>Elev Diff</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>Chn Width</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>Slope</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(12)}}>{r?.cross_section}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>{r?.left_sta_elev[0]}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>{r?.right_sta_elev[0]}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>{r?.left_sta_elev[1]}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>{r?.right_sta_elev[1]}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>{r?.elev_diff}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>{r?.chn_diff}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(8)}}>{r?.slope}</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        case MessageCodes.Internal.XS4_XS08.error_id: {
            return (
                <>
                    <ResultText>
                        The cross sections listed in the table have one of the following issues regarding the channel width between the bank stations.
                        <br/>
                        1.	The channel width deviates from the reach averaged channel width ({row?.average} ft) more than {settings?.thresholds?.reach_average_dev}%.
                        <br/>
                        2.	The channel width deviates from the US/DS (bounding) cross section average more than {settings?.thresholds?.bounding_average_dev} %.
                        <br/>
                        These may indicate misplacement of the bank stations.
                    </ResultText>
                    <EmptyLine />
                    <ResultTable data={row}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}></ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'center', width: HecRasHelper.getWidth(12)}}></ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{textAlign: 'center', width: HecRasHelper.getWidth(20)}}>% Deviation from Average</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>Chn Width (ft)</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>Reach</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10)}}>US/DS</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(r => (
                                    <ResultRow>
                                        <ResultBodyCell style={{textAlign: 'start', width: HecRasHelper.getWidth(15)}}>{r?.cross_section}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(12)}}>{r?.top_w_channel}</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10), color: Math.abs(r?.dev_reach_avg) > settings?.thresholds?.reach_average_dev ? 'red' : ''}}>{r?.dev_reach_avg} %</ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'end', width: HecRasHelper.getWidth(10), color: Math.abs(r?.dev_usds_avg) > settings?.thresholds?.bounding_average_dev ? 'red' : ''}}>{r?.dev_usds_avg} %</ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}